export const branchNames = ['A', 'B', 'C', 'D'];
